"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlManager = void 0;
var types_1 = require("./types");
var UrlManager;
(function (UrlManager) {
    UrlManager.clearParams = function (historyStep) {
        var _a = window.location, protocol = _a.protocol, host = _a.host, pathname = _a.pathname, hash = _a.hash;
        var newLocation = "".concat(protocol, "//").concat(host).concat(pathname).concat(hash);
        // Using History API!
        if (window.history) {
            window.history.pushState(historyStep, newLocation);
        }
        else {
            // Fallback for browsers with no History api support
            window.location.href = newLocation;
        }
    };
    UrlManager.removeURLParameter = function (url, parameter) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {
            var prefix = encodeURIComponent(parameter) + '=';
            var parameters = urlparts[1].split(/[&;]/g);
            for (var i = parameters.length; i-- > 0;) {
                if (parameters[i].lastIndexOf(prefix, 0) !== -1) {
                    parameters.splice(i, 1);
                }
            }
            return urlparts[0] + (parameters.length > 0 ? '?' + parameters.join('&') : '');
        }
        return url;
    };
    UrlManager.parseParams = function () {
        var hash = {};
        window.location.search
            .substring(1)
            .split('&')
            .forEach(function (params) {
            var _a = __read(params.split('='), 2), name = _a[0], value = _a[1];
            hash[name] = value;
        });
        return hash;
    };
    /**
     * Retrieve root domain for url **.com
     * @param
     * @returns string
     */
    UrlManager.getUrlDomainRoot = function () {
        var domainRoot = window
            ? window.location.hostname
                .split('.')
                .slice(-2)
                .join('.')
            : 'gwi.com';
        return domainRoot;
    };
    UrlManager.getAppUrl = function () {
        var loc = window.location;
        return "".concat(loc.protocol, "//").concat(loc.host);
    };
    UrlManager.isOpenAccess = function (environment) {
        var host = window.location.host;
        return types_1.OpenAccessHostURL[environment] === host;
    };
})(UrlManager = exports.UrlManager || (exports.UrlManager = {}));
